/*
 * @Description: 项目配置
 * @Date: 2021-03-22 00:21:31
 */

import runConfig from '@Config/run_config.json';

export const TOKEN_KEY = 'authentication';

export const REQUEST_PATH = '';

export const REQUEST_DOMAIN = runConfig['env'].PROXY;

export const XCX_PATH = runConfig['env'].XCX_DOMAIN;

export const FILE_VIEW_URL =
  'https://oss.myxrk.com/myxrk-v2/front-end/html/file-view/index.html';

export const SUN_WEB_URL = process.env.VUE_APP_SUN_URL;

export const BI_URL = runConfig['env'].BI_DOMAIN + process.env.VUE_APP_BI_PATH;

export const REPORT_URL =
  runConfig['env'].BI_DOMAIN + process.env.VUE_APP_REPORT_PATH;

export const QQ_MAP_KEY = 'ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU';

export const PLATFORM_TYPE = runConfig['platform-type'] as 1 | 2; // 平台类型，区分1向日葵平台、2独立平台

export const IS_PLATFORM_TYPE_1 = PLATFORM_TYPE === 1;

export const IS_PLATFORM_TYPE_2 = PLATFORM_TYPE === 2;

export const PLATFORM_ID = runConfig['platform-id']; // 平台\独立平台 ID，用于全局请求头，比如三个独立项目PLATFORM_TYPE都为2，id不同，可能为101、102、103

export const PLATFORM_IS_FEIGON = runConfig['platform-id'] === 2001; //飞冠（飞冠例外 走经营没劳务只有技术服务费）

export const PLATFORM_IMAGES = runConfig['images']; // 平台\独立平台 图片地址 logo 登录页背景图等

export const PLATFORM_NAME = runConfig['project-name']; // 平台\独立平台 名称
